export const attendeeDetailsStyle = {
  wrapper: {
    width: '100%',
    maxWidth: '970px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
    marginBottom: '24px',

    '& .MuiTypography-body1': {
      color: 'var(--neutral-300)',
    },
  },

  tabs: {
    background: 'var(--default-white)',
    padding: '24px 0',
    maxHeight: '36px',
    borderRadius: '8px 8px 0 0',
    marginBottom: '40px',
  },

  tab: {
    maxWidth: '315px',
    width: '100%',
    zIndex: 99,
  },
};
